<template>
    <h2 style="margin-top: 2em;">{{message}}</h2>
</template>
<script>
import firebase from '@/firebase/init'
export default { 
    name: 'Decline',
    data(){
        return{
            message: null
        }
    },
    created(){
        var email
        var token = this.$route.params.token
        var db = firebase.firestore()
        var thisRef = this
        let ref = db.collection('users').where('DeclineToken', '==', token)
        ref.get().then(snapshot=>{
            if(!snapshot.empty){
                    snapshot.forEach(doc=>{
                        email = doc.data().Email
                        var userRef = db.collection("users").doc(doc.id)
                        userRef.update({
                            Approved: false,
                            ApproveToken: firebase.firebase_.firestore.FieldValue.delete(),
                            DeclineToken: firebase.firebase_.firestore.FieldValue.delete()
                        })
                        .then(function() {
                           thisRef.message = "Account is declined"
                           let sendMail = firebase.functions().httpsCallable('sendDeclinedMail')
                            sendMail({email : email})
                        })
                        .catch(function(error) {
                            thisRef.message = "Error declining document"
                            console.error("Error declining document: ", error)
                        })
                    })
            }
            else{
                this.message = "Token doesn't exist"
            }
          })
        
    },
    beforeCreate: function() {
            document.body.className = 'registration'
            this.$parent.showNavbar = false        
    }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/admin/Decline.vue